import moment from 'moment-timezone';
import store from '../../../stores/redux';

const getLocale = () => {
    return store.getState().user.locale || 'en';
};

const getTimeZone = () => {
    return (
        store.getState()?.user?.timezone ||
        (Intl.DateTimeFormat().resolvedOptions
            ? Intl.DateTimeFormat().resolvedOptions().timeZone
            : 'UTC') ||
        'UTC'
    );
};

const parseDate = (value, isMomentOrTZ = false, maybeTZ) => {
    let isMoment = false;
    let tz =
        (typeof getTimeZone === 'function' && getTimeZone()) ||
        (Intl.DateTimeFormat().resolvedOptions
            ? Intl.DateTimeFormat().resolvedOptions().timeZone
            : 'UTC') ||
        'UTC';

    if (typeof isMomentOrTZ === 'string') {
        tz = isMomentOrTZ || tz;
    } else {
        isMoment = !!isMomentOrTZ;
        tz = maybeTZ || tz;
    }

    const m = moment.isMoment(value) ? value.clone() : moment(value);
    const mTz = tz ? m.tz(tz) : m;

    return isMoment ? mTz : mTz.toDate();
};

const convert = (seconds) => {  // millisecond translation
    return seconds * 1000;
};

export {
    getLocale,
    getTimeZone,
    convert,
    parseDate
};
